import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { HtmlRenderer } from '../../components/htmlAreas/htmlRenderer';
import { TwemojiWrapper } from '../../components/twemojiWrapper';
import { LIGHT_YELLOW_COLOR, ME_PRIVATE_MESSAGE_BACKGROUND_COLOR, THEM_PRIVATE_MESSAGE_BACKGROUND_COLOR } from '../../styles/colors';
import { assertUnreachable } from '../../utils/tsUtils';
const CONTAINER_CSS = css `
  display: flex;
  flex-direction: row;
`;
const MESSAGE_BASE_CSS = css `
  color: black;
  border-radius: 7px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  overflow-wrap: break-word; // allow breaking anywhere to avoid horizontal scrollbar
`;
const NO_SENDER_MESSAGE_CSS = css(MESSAGE_BASE_CSS, css `
    background-color: ${LIGHT_YELLOW_COLOR};
    max-width: 100%;
    padding: 5px;
    margin: 0 auto;
  `);
const SENDER_MESSAGE_BASE_CSS = css(MESSAGE_BASE_CSS, css `
    padding: 2px 5px;
    max-width: 90%;
  `);
const ME_SENDER_MESSAGE_CSS = css(SENDER_MESSAGE_BASE_CSS, css `
    background-color: ${ME_PRIVATE_MESSAGE_BACKGROUND_COLOR};
  `);
const OTHER_SENDER_MESSAGE_CSS = css(SENDER_MESSAGE_BASE_CSS, css `
    background-color: ${THEM_PRIVATE_MESSAGE_BACKGROUND_COLOR};
  `);
const SPACER_CSS = css `
  min-width: 10%;
  width: 10%;
  flex-grow: 1;
`;
const TYPOGRAPHY_CSS = css `
  line-height: 125%;
`;
function getMessageCss(senderType) {
    switch (senderType) {
        case 'me': {
            return ME_SENDER_MESSAGE_CSS;
        }
        case 'them': {
            return OTHER_SENDER_MESSAGE_CSS;
        }
        case undefined: {
            return NO_SENDER_MESSAGE_CSS;
        }
        default: {
            assertUnreachable(senderType);
        }
    }
}
function getSenderType(fromPlayerId, myPlayerId) {
    if (fromPlayerId === undefined || myPlayerId === undefined) {
        return;
    }
    return fromPlayerId === myPlayerId ? 'me' : 'them';
}
function getAriaLabel(conversationPlayer, senderType) {
    switch (senderType) {
        case 'me': {
            return 'Me';
        }
        case 'them': {
            return conversationPlayer.name;
        }
        case undefined: {
            return;
        }
        default: {
            assertUnreachable(senderType);
        }
    }
}
const DirectMessageDisplay = React.memo(({ conversationPlayer, message, myPlayerId }) => {
    const senderType = getSenderType(message.fromPlayerId, myPlayerId);
    return (_jsxs("div", { "aria-label": getAriaLabel(conversationPlayer, senderType), css: CONTAINER_CSS, className: 'scaling-panel-contents', children: [senderType === 'me' && _jsx("div", { css: SPACER_CSS }), _jsx("div", { css: getMessageCss(senderType), children: _jsx(TwemojiWrapper, { children: _jsx(Typography, { component: 'div', css: TYPOGRAPHY_CSS, sx: { fontSize: 'inherit' }, children: _jsx(HtmlRenderer, { html: message.html }) }) }) }), senderType === 'them' && _jsx("div", { css: SPACER_CSS })] }));
});
DirectMessageDisplay.displayName = 'DirectMessageDisplay';
export { DirectMessageDisplay };
